var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
import 'photoswipe/style.css';
import { isWebpSupported } from "../utils";
export function initPhotoPopups() {
    var defaults = {
        children: 'a',
        pswpModule: PhotoSwipe,
        bgClickAction: 'close',
        bgOpacity: 1,
        closeTitle: 'Закрыть',
        zoomTitle: 'Увеличить',
        initialZoomLevel: function (_a) {
            var panAreaSize = _a.panAreaSize, itemData = _a.itemData;
            if (panAreaSize.y > panAreaSize.x) {
                var maxSize = Math.min(panAreaSize.x, panAreaSize.y - 120);
                var imageMaxSize = Math.max(itemData.width, itemData.height);
                return Math.min(maxSize / imageMaxSize, 1);
            }
            return Math.min(panAreaSize.x / itemData.width, (panAreaSize.y - 120) / itemData.height, 1);
        },
        arrowPrevTitle: 'Предыдущая фотография',
        arrowNextTitle: 'Следующая фотография',
        errorMsg: 'Не удалось загрузить фотографию',
    };
    var productGallery = new PhotoSwipeLightbox(__assign(__assign({}, defaults), { gallery: '#prod-item-swiper' }));
    var initialSlide;
    productGallery.addFilter('clickedIndex', function (index) { return initialSlide = index; });
    productGallery.addFilter('itemData', parseWebpSource);
    productGallery.addFilter('itemData', function (data, index) { return (__assign(__assign({}, data), { autoplay: initialSlide === index })); });
    productGallery.addFilter('thumbBounds', calculateThumbBounds);
    // support youtube content
    productGallery.on('contentLoad', function (e) {
        var content = e.content;
        if (content.type === 'youtube') {
            e.preventDefault();
            content.element = document.createElement('div');
            content.element.className = 'pswp__youtube-container';
            var iframe = document.createElement('iframe');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay');
            iframe.width = '100%';
            iframe.height = '100%';
            iframe.src = content.data.src.replace(/\/watch\?v=/, '/embed/') + '?enablejsapi=1' + (content.data.autoplay ? '&autoplay=1' : '');
            content.element.appendChild(iframe);
        }
    });
    productGallery.on('change', function () {
        document.getElementById('prod-item-swiper').swiper.slideTo(productGallery.pswp.currIndex);
    });
    productGallery.on('contentDeactivate', function (_a) {
        var content = _a.content;
        if (content.data.type === 'youtube') {
            content.element.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
    });
    productGallery.init();
    var reviewGallery = new PhotoSwipeLightbox(__assign(__assign({}, defaults), { gallery: '.review-item__photos' }));
    reviewGallery.addFilter('thumbBounds', calculateThumbBounds);
    reviewGallery.addFilter('itemData', parseWebpSource);
    reviewGallery.init();
}
function calculateThumbBounds(_thumbBounds, itemData) {
    var imageAspectRatio = itemData.width / itemData.height;
    var boxWidth = itemData.element.clientWidth;
    var boxHeight = itemData.element.clientHeight;
    var boxAspectRatio = itemData.element.clientWidth / itemData.element.clientHeight;
    var boxRect = itemData.element.getBoundingClientRect();
    if (boxAspectRatio > imageAspectRatio) {
        var width = boxWidth * (imageAspectRatio / boxAspectRatio);
        return {
            w: width,
            x: boxRect.x + (boxWidth - width) / 2,
            y: boxRect.y,
        };
    }
    return {
        w: boxWidth,
        x: boxRect.x,
        y: boxRect.y + (boxHeight - boxHeight * (boxAspectRatio / imageAspectRatio)) / 2,
    };
}
function parseWebpSource(itemData) {
    if (isWebpSupported()) {
        itemData.src = itemData.src.replace(/(\.bmp)?\.(jpe?g|png|gif)$/i, '\.webp');
    }
    return itemData;
}
